import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { PowerUpPage } from "./pages/PowerUpPage";
import { GoalgeousPage } from "./pages/GoalgeousPage";
import { ClubDeucesPage } from "./pages/ClubDeucesPage";
import { GoalTritonPage } from "./pages/GoalTritonPage";
import { ShockTheBodyPage } from "./pages/ShockTheBodyPage";
import { InstructorsPage } from "./pages/InstructorsPage";
import { AccountabilityCheckPage } from "./pages/AccountabilityCheckPage";
import { BookNowPage } from "./pages/BookNowPage";
import { AdminLoginPage } from "./pages/AdminLoginPage";
import { AdminDashboardPage } from "./pages/AdminDashboardPage";
import { ContentEditorPage } from "./pages/ContentEditorPage";
import { FormSettingsPage } from "./pages/FormSettingsPage";

// Layout component that conditionally shows navbar/footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isClubDeuces = location.pathname === '/club-deuces';
  const isShockTheBody = location.pathname === '/shock-the-body';
  const isAdmin = location.pathname.startsWith('/admin');
  const hideMainNav = isClubDeuces || isShockTheBody || isAdmin;
  
  return (
    <>
      {!hideMainNav && <Navbar />}
      <main>{children}</main>
      {!hideMainNav && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App bg-brand-black min-h-screen">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/power-up" element={<PowerUpPage />} />
            <Route path="/goalgeous-university" element={<GoalgeousPage />} />
            <Route path="/club-deuces" element={<ClubDeucesPage />} />
            <Route path="/goal-trition" element={<GoalTritonPage />} />
            <Route path="/shock-the-body" element={<ShockTheBodyPage />} />
            <Route path="/instructors" element={<InstructorsPage />} />
            <Route path="/accountability-check" element={<AccountabilityCheckPage />} />
            <Route path="/book-now" element={<BookNowPage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/content/accountability-chats" element={<ContentEditorPage />} />
            <Route path="/admin/forms/choose-you-intake" element={<FormSettingsPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
